/* eslint-disable camelcase */

import { get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from "react-router-dom";
import ProgressBar from '../../../shared/components/ProgressBar/ProgressBar';
import SignUpStep1 from './SignUp__Step1';
import SignUpStep2 from './SignUp__Step2';
import SignUpStep3 from './SignUp__Step3';

const calculatePercentageBar = (step, total) => Math.ceil((step - 1) * 100 / total);

const SignUp = () => {
  const { user } = useSelector(state => state.auth);
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState({
    step: 1,
    progressBarPercentage: calculatePercentageBar(1, 3)
  });

  useEffect(() => {
    if (!location.pathname.includes("step-1") && !user) {
      return history.replace('/signin');
    }
    if (location.pathname.includes("step-2")) {
      return goToStep(2);
    }
    if (location.pathname.includes("step-3")) {
      return goToStep(3);
    }
  }, []);

  useEffect(() => {
    if (user) {
      if(user.activated) {
        return history.replace('/');
      }

      if (
        !get(user, 'social.inst.nickname') &&
        !get(user, 'social.tikt.nickname') &&
        !get(user, 'social.yout.nickname') &&
        !get(user, 'social.link.nickname')
      ) {
        return goToStep(2);
      }

      if (
        !get(user, 'city_id') ||
        !get(user, 'dob') ||
        !get(user, 'gender')
      ) {
        return goToStep(3);
      }
    }
  }, [user]);

  const goToStep = useCallback((step) => {
    setState({
      ...state,
      step,
      progressBarPercentage: calculatePercentageBar(step, 3)
    });

    history.push({
      pathname: `/sign-up/step-${step}`
    });
  }, [state]);


  const { step } = state;
  return (<Container className="mt-4">
    <ProgressBar className="mb-6" now={state.progressBarPercentage} />
    {step === 1 && <SignUpStep1 goToStep={goToStep} />}
    {step === 2 && <SignUpStep2 goToStep={goToStep} />}
    {step === 3 && <SignUpStep3 user={user} />}
  </Container>);
};

export default SignUp;
